export default "__VITE_ASSET__BytjukjO__"